import { ubtButtonNew, ubtModuleExposeNew } from '@/shared/utils/ubt';
import { RightTipsDialogActionEnum, RightTipsDialogSceneEnum, RightTipsDialogUbtEnum } from '@/views_v2/apply-product/components/rights/zhenxiang-card/enum';
import { Dialog } from '@hb/coffee';
import router from '@/router';

export const RightDataDialog = {
  /** 是否展示了权益概要数据查询错误弹窗 */
  showSummaryDataTips: false,

  /** 埋点数据上报通用封装 */
  sendUbtData(params: Dictionary, type?: RightTipsDialogUbtEnum):void {
    const pageId = (router.currentRoute.meta?.pageId as string) || '';
    const moduleId = 'finance_loan_withdrawal_rightsTipDialog';
    if (type === RightTipsDialogUbtEnum.EXPOSE) {
      ubtModuleExposeNew(
        pageId,
        moduleId,
        params,
      );
    } else {
      ubtButtonNew(
        pageId,
        moduleId,
        params,
      );
    }
  },

  closeDialog: ():void => {
    if (RightDataDialog.showSummaryDataTips) {
      Dialog.close();
      RightDataDialog.showSummaryDataTips = false;
    }
  },

  /** 扩展封装，权益接口数据返回异常或者提现接口返回权益错误相关的code，执行callback:刷新页面的操作 */
  showDialog: (
    scene: RightTipsDialogSceneEnum,
    action: RightTipsDialogActionEnum,
    callback?: ()=>void,
  ):void => {
    // TODO:埋点定义封装
    RightDataDialog.showSummaryDataTips = true;
    RightDataDialog.sendUbtData({ scene }, RightTipsDialogUbtEnum.EXPOSE);
    Dialog.confirm({
      title: '温馨提示',
      message: '由于网络异常页面无法正常展示，请点击刷新按钮或退出页面重新进入页面进行尝试',
      confirmButtonText: '刷新',
      closeable: false,
      showCancelButton: true,
      cancelButtonText: '我知道了',
    }).then(() => {
      RightDataDialog.sendUbtData({ scene, action });
      // 增加点击埋点
      RightDataDialog.showSummaryDataTips = false;

      if (callback) {
        callback();
      }
    });
  },
};
